import { ChangeEvent, FC } from "react";
import { usePopup } from "../../hooks/popup.hook";
import styles from "./addon-popup.module.css";
import { UiButton, UiInput } from "@ui-monorepo/index";
import X from "@sumerkit/icons/x/ssr";
import CopySimple from "@sumerkit/icons/copy-simple/ssr";
import Check from "@sumerkit/icons/check/ssr";
import { useTranslation } from "react-i18next";

interface AddonPopupProps {}

const AddonPopup: FC<AddonPopupProps> = () => {
  const { t } = useTranslation();
  const {
    isOk,
    showPopup,
    popup,
    subscriptionEmail,
    couponCode,
    backupImagePopupFirstPurchase,
    itIsCopy,
    backupTextButton,
    backupGeneralText,
    handleClose,
    setSubscriptionEmail,
    handleSubscription,
    isValidEmail,
    handleCopy
  } = usePopup();

  return !!popup && popup.enabled && showPopup ?
  <div className={`${styles.wrapper} ${!popup?.imageEnabled && styles.noImage}`}>
      <div className={styles.overlay} />
      <div className={styles.modal}>
        <div className={styles.close} onClick={handleClose}>
          <X className={styles.icon} />
        </div>
        {popup?.imageEnabled &&
      <img
        src={popup.image || backupImagePopupFirstPurchase}
        alt='Cloth'
        className={styles.img} />}


        <div className={styles.content}>
          {!couponCode ?
        <>
              <div className={styles.off}>{popup.discountValue}% OFF</div>
              <div className={styles.description}>{t("firstPurchase.title")}</div>
              <div className={styles.phases}>{popup.text ? popup.text : backupGeneralText}  </div>
              <UiInput
            className={styles.input}
            placeholder={t("firstPurchase.placeholder")}
            value={subscriptionEmail}
            hasError={!isOk}
            errorMessage={t("firstPurchase.error_message")}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setSubscriptionEmail(e.target.value);
            }} />

              <UiButton
            isFilled
            className={styles.button}
            onClick={handleSubscription}
            disabled={!isValidEmail(subscriptionEmail)}>

                {popup.buttonText ? popup.buttonText : backupTextButton} 
              </UiButton>
            </> :

        <>
              <div className={styles.okTitle}>{t("firstPurchase.enjoyFirstPurchase.title")}</div>
              <div className={styles.okDescription}>
              {t("firstPurchase.enjoyFirstPurchase.description")} {popup.discountValue}% {t("firstPurchase.enjoyFirstPurchase.discount")}
              </div>
              <div className={styles.code}>
                <div className={styles.box}>{couponCode}</div>
                <div className={styles.icon} onClick={() => handleCopy(couponCode)}>
                  {itIsCopy ? <Check /> : <CopySimple />}
                </div>
              </div>
              <div className={styles.emailToo}>{t("firstPurchase.enjoyFirstPurchase.text_mail")}</div>
            </>}

        </div>
      </div>
    </div> :
  null;
};

export default AddonPopup;